(() => {
  const initSlider = (slider) => {
    if (!slider || slider.dataset.swipeReady === 'true') return;

    const track = slider.querySelector('[data-product-card-track]');
    const slides = slider.querySelectorAll('[data-product-card-slide]');
    const prev = slider.querySelector('[data-product-card-prev]');
    const next = slider.querySelector('[data-product-card-next]');

    if (!track || slides.length < 2 || !prev || !next) return;

    slider.dataset.swipeReady = 'true';
    let currentIndex = 0;
    let scrollFrame = null;

    const updateControls = () => {
      const slideWidth = track.clientWidth || 1;
      currentIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / slideWidth)));
      prev.disabled = currentIndex === 0;
      next.disabled = currentIndex === slides.length - 1;
      slider.dataset.activeImage = String(currentIndex + 1);
    };

    const moveTo = (index) => {
      const nextIndex = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: nextIndex * track.clientWidth, behavior: 'smooth' });
    };

    prev.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      moveTo(currentIndex - 1);
    });

    next.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      moveTo(currentIndex + 1);
    });

    track.addEventListener('scroll', () => {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(updateControls);
    }, { passive: true });

    updateControls();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-product-card-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
